import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
  ],
})
export class FileUploadComponent implements ControlValueAccessor {
  @Input() labelKey: string;
  @Input() accept: string;
  @Input() control: any;
  @Output() fileuploadEvent = new EventEmitter<string>();

  value: File | null = null;
  onChange: (value: File | null) => void = () => {};
  onTouched: () => void = () => {};

  constructor() {}

  onFileChange(event: any) {
    const file = event.target.files[0];
    this.value = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        this.addNewItem(reader.result as string);
    };
    this.control.setValue(file);
    this.onChange(this.value);
    this.onTouched();
  
  }

  addNewItem(value: string) {
    this.fileuploadEvent.emit(value);
  }

  writeValue(value: File | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: File | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // You can implement this if needed
  }
}
